import React from 'react';
import { Card, CardContent } from './ui/card';
import { Building2, Hammer, Home, ArrowRight } from 'lucide-react';
import { services } from '../mockData';

const iconMap = {
  building: Building2,
  hammer: Hammer,
  home: Home
};

const ServicesSection = () => {
  return (
    <section id="services" className="py-24 bg-gradient-to-b from-white to-gray-50">
      <div className="container mx-auto px-6">
        {/* Section header */}
        <div className="text-center max-w-3xl mx-auto mb-20 space-y-4">
          <span className="bg-gradient-to-r from-yellow-500 to-yellow-400 text-white px-5 py-2.5 rounded-full text-sm font-semibold shadow-lg">
            Nos Services
          </span>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900">
            Une expertise complète pour
            <span className="block mt-2 bg-gradient-to-r from-yellow-500 to-yellow-400 bg-clip-text text-transparent">
              tous les projets immobiliers
            </span>
          </h2>
        </div>

        {/* Services grid */}
        <div className="grid md:grid-cols-3 gap-8 max-w-6xl mx-auto">
          {services.map((service) => {
            const IconComponent = iconMap[service.icon];
            return (
              <Card
                key={service.id}
                className="group relative overflow-hidden hover:shadow-2xl transition-all duration-300 border-2 border-gray-100 hover:border-yellow-200 cursor-pointer bg-white"
              >
                {/* Background gradient on hover */}
                <div className="absolute inset-0 bg-gradient-to-br from-blue-50 to-white opacity-0 group-hover:opacity-100 transition-opacity"></div>
                
                {/* Image */}
                <div className="relative h-80 overflow-hidden bg-gray-100">
                  <img
                    src={service.image}
                    alt={service.title}
                    className={`w-full h-full ${service.id === 1 || service.id === 2 ? 'object-contain' : 'object-cover'} group-hover:scale-110 transition-transform duration-500 ${service.id === 2 ? 'brightness-110' : ''}`}
                  />
                  <div className={`absolute inset-0 bg-gradient-to-t ${service.id === 2 ? 'from-black/30' : 'from-black/60'} to-transparent`}></div>
                  
                  {/* Icon on image */}
                  <div className="absolute bottom-4 left-4">
                    <div className="bg-gradient-to-br from-yellow-500 to-yellow-400 p-3 rounded-xl shadow-xl">
                      <IconComponent className="text-white" size={28} />
                    </div>
                  </div>
                </div>

                <CardContent className="p-8 space-y-4 relative z-10">
                  {/* Content */}
                  <h3 className="text-2xl font-bold text-gray-900 group-hover:text-yellow-600 transition-colors">
                    {service.title}
                  </h3>
                  <p className="text-gray-600 leading-relaxed">
                    {service.description}
                  </p>

                  {/* Features */}
                  <ul className="space-y-2 pt-4">
                    {service.features.slice(0, 3).map((feature, idx) => (
                      <li key={idx} className="flex items-start gap-2 text-sm text-gray-700">
                        <div className="w-1.5 h-1.5 bg-yellow-500 rounded-full mt-2"></div>
                        <span>{feature}</span>
                      </li>
                    ))}
                  </ul>

                  {/* Hover arrow */}
                  <div className="flex items-center gap-2 text-yellow-600 font-semibold text-sm opacity-0 group-hover:opacity-100 transition-opacity pt-2">
                    <span>En savoir plus</span>
                    <ArrowRight size={16} className="group-hover:translate-x-1 transition-transform" />
                  </div>
                </CardContent>
              </Card>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;
